const handleScrollTo = (coordinate) => {
	$('html, body').animate({
		scrollTop: coordinate
	}, 1000);
}

$(document).on('click', '.js-faq-nav__item > a', function(event) {
	const $this = $(this);
	const $section = $($this.attr('href'));

	if ($section.length === 0) {
		return;
	}

	handleScrollTo($section.offset().top)

	event.preventDefault();
});
